module.exports = __webpack_public_path__ + "static/media/PP035.b0705508.jpg";